var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--tru-primary-color)",
    fillRule: "evenodd",
    d: "M38.828 22.038c.051-9.222-7.47-16.788-16.768-16.866-9.222-.077-16.84 7.496-16.888 16.789-.048 9.224 7.47 16.787 16.767 16.867 9.223.079 16.837-7.49 16.889-16.79ZM20.625 0h2.75c.11.024.22.054.331.071 1.13.175 2.275.28 3.386.534 8.473 1.937 15.14 9.031 16.574 17.603.135.802.224 1.611.334 2.417v2.75c-.024.11-.056.22-.072.332-.15 1.018-.244 2.047-.452 3.053-1.762 8.528-9.057 15.508-17.643 16.9-.816.133-1.639.228-2.458.34h-2.75c-.096-.023-.19-.054-.287-.069-1.004-.146-2.018-.243-3.011-.442-8.53-1.707-15.59-9.037-16.983-17.612-.135-.83-.23-1.668-.344-2.502v-2.75c.14-.974.246-1.955.426-2.922C2.06 8.947 9.38 1.783 18.166.34c.816-.135 1.64-.227 2.459-.339Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--tru-primary-color)",
    fillRule: "evenodd",
    d: "M18.129 21.972a3.87 3.87 0 0 0 3.854 3.9c2.131.006 3.87-1.704 3.888-3.823.018-2.155-1.695-3.907-3.832-3.92-2.153-.014-3.9 1.704-3.91 3.843Zm3.92-9.071c4.393.064 8.585.908 12.492 2.979.31.164.502.374.633.701 1.175 2.923 1.375 5.907.63 8.965-.078.322-.229.426-.54.462-1.83.21-3.555.74-5.088 1.79-2.336 1.6-3.544 3.9-4.05 6.624a8.756 8.756 0 0 0-.083.508c-.097.774-.094.781-.84.95a14.31 14.31 0 0 1-6.802-.094c-.268-.069-.365-.184-.396-.45-.217-1.858-.741-3.614-1.81-5.171-1.595-2.322-3.882-3.523-6.588-4.034a9.097 9.097 0 0 0-.507-.085c-.811-.105-.82-.103-.994-.898-.65-2.967-.402-5.858.773-8.66.09-.214.289-.43.493-.542 2.835-1.55 5.882-2.434 9.083-2.789 1.193-.133 2.396-.174 3.595-.256Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default ForwardRef;